class TimeType {
    static MORNING = "MORNING";
    static AFTERNOON = "AFTERNOON";
    static EVENING = "EVENING";

    static getTimeTypeString(timeType: TimeType): string {
        switch (timeType) {
            case this.MORNING:
                return "아침 약속";
            case this.AFTERNOON:
                return "점심 약속";
            case this.EVENING:
                return "저녁 약속";
            default:
                throw new Error("정의되지 않은 시간대입니다.")
        }
    }

    static getTimeTypeStringForTag(timeType: TimeType): string {
        switch (timeType) {
            case this.MORNING:
                return "오전 시간대 ⛅️";
            case this.AFTERNOON:
                return "점심 시간대 🌞";
            case this.EVENING:
                return "저녁 시간대 🌙";
            default:
                throw new Error("정의되지 않은 시간대입니다.")
        }
    }
}

export default TimeType;